import { Badge } from "@/components/ui/v2/badge";
import { StatusType } from "@/types/StatusType";
import { TransactionDirection } from "@/types/transaction/TransactionType";
import { formatCurrency } from "@/utils/valueFormat";

type BadgeCurrencyCellProps = {
  value: number;
  type?: StatusType;
  direction?: TransactionDirection;
};

const BadgeCurrencyCell = ({
  value,
  type,
  direction,
}: BadgeCurrencyCellProps) => {
  return (
    <Badge variant={type ?? "default"}>
      {`${
        direction === "Credit" ? "+ " : direction === "Debit" ? "- " : ""
      }${formatCurrency(value)}`}
    </Badge>
  );
};

export default BadgeCurrencyCell;
